// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { PotentialOperationDetailsFragmentDoc } from '../../../../queries/fragments.generated';
import { DesignPackageProductCardPage_OptionCombinationFragmentDoc } from '../design-package-configurator/DesignPackageProductCardPage.generated';
import { NamedFragmentDoc } from '../../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type EditPersonalizationOptionWizardQueryVariables = Types.Exact<{
  dpId: Types.Scalars['ID']['input'];
  rpavId: Types.Scalars['ID']['input'];
  rpogId: Types.Scalars['ID']['input'];
  isAdd: Types.Scalars['Boolean']['input'];
  forTliId: Types.Scalars['ID']['input'];
  hasTliId: Types.Scalars['Boolean']['input'];
}>;


export type EditPersonalizationOptionWizardQuery = { __typename?: 'Query', enumDetails: { __typename?: 'AllEnumDetails', readyPlanOptionGroupPersonalizationType: Array<{ __typename?: 'ReadyPlanOptionGroupPersonalizationTypeDetail', code: Types.ReadyPlanOptionGroupPersonalizationType, name: string }> }, designPackage: { __typename?: 'DesignPackage', id: string, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, availableTargetGroups: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string, name: string, groupByFeature: boolean, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string }> }> }, takeoffLineItem?: { __typename?: 'TakeoffLineItem', id: string, personalizationSlotOrder?: number | null | undefined, name: string, targetGroups: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string }>, products: Array<{ __typename?: 'TakeoffLineItem', id: string, active: boolean, materialVariant?: { __typename?: 'MaterialVariant', id: string, displayName: string, listing: { __typename?: 'MaterialListing', id: string, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined }, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined } | null | undefined, materialAttributeValues: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string, dimension: { __typename?: 'MaterialAttributeDimension', id: string, name: string } }> } | null | undefined, targetCombinations: Array<{ __typename?: 'DesignPackageOptionCombination', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> }> }>, location: { __typename?: 'Location', id: string, displayLocationPath: string }, materialVariant?: { __typename?: 'MaterialVariant', id: string } | null | undefined }, readyPlan?: { __typename?: 'ReadyPlan', id: string, optionGroups: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string, name: string, marketingDescription?: string | null | undefined, levels?: number | null | undefined, displayPackageOptionsAsSingleProduct?: boolean | null | undefined, groupByFeature: boolean, personalizationTargetGroups: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string }>, personalizationPlaceholders: Array<{ __typename?: 'TakeoffLineItem', id: string, personalizationRpoShadowPlaceholder?: { __typename?: 'TakeoffLineItem', id: string, products: Array<{ __typename?: 'TakeoffLineItem', id: string, materialVariant?: { __typename?: 'MaterialVariant', id: string, displayName: string, listing: { __typename?: 'MaterialListing', id: string, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined }, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined } | null | undefined, materialAttributeValues: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string, dimension: { __typename?: 'MaterialAttributeDimension', id: string, name: string } }> } | null | undefined, options: Array<{ __typename?: 'ReadyPlanOption', id: string }>, placeholder?: { __typename?: 'TakeoffLineItem', id: string, materialVariant?: { __typename?: 'MaterialVariant', id: string } | null | undefined } | null | undefined, location: { __typename?: 'Location', id: string } }> } | null | undefined, personalizationPlaceholderControlledSlots: Array<{ __typename?: 'TakeoffLineItem', personalizationSlotOrder?: number | null | undefined, id: string, name: string, location: { __typename?: 'Location', id: string, displayLocationPath: string }, materialVariant?: { __typename?: 'MaterialVariant', id: string } | null | undefined, products: Array<{ __typename?: 'TakeoffLineItem', id: string, active: boolean, materialVariant?: { __typename?: 'MaterialVariant', id: string, displayName: string, listing: { __typename?: 'MaterialListing', id: string, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined }, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined } | null | undefined, materialAttributeValues: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string, dimension: { __typename?: 'MaterialAttributeDimension', id: string, name: string } }> } | null | undefined, targetCombinations: Array<{ __typename?: 'DesignPackageOptionCombination', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> }> }> }> }>, personalizationType?: { __typename?: 'ReadyPlanOptionGroupPersonalizationTypeDetail', code: Types.ReadyPlanOptionGroupPersonalizationType, name: string } | null | undefined, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, materialVariant?: { __typename?: 'MaterialVariant', id: string, displayName: string, listing: { __typename?: 'MaterialListing', id: string, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined }, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined } | null | undefined, materialAttributeValues: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string, dimension: { __typename?: 'MaterialAttributeDimension', id: string, name: string } }> } | null | undefined, personalizationTargetCombinations: Array<{ __typename?: 'DesignPackageOptionCombination', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string }> }> }> }> } };

export type EditPersonalizationOptionWizard_MaterialVariantQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type EditPersonalizationOptionWizard_MaterialVariantQuery = { __typename?: 'Query', materialVariant: { __typename?: 'MaterialVariant', id: string, displayName: string, listing: { __typename?: 'MaterialListing', id: string, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined }, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined } | null | undefined, materialAttributeValues: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string, dimension: { __typename?: 'MaterialAttributeDimension', id: string, name: string } }> } };

export type EditPersonalizationOptionWizard_CombinationsQueryVariables = Types.Exact<{
  dpId: Types.Scalars['ID']['input'];
  rpavId: Types.Scalars['ID']['input'];
  targetGroupIds: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
}>;


export type EditPersonalizationOptionWizard_CombinationsQuery = { __typename?: 'Query', designPackage: { __typename?: 'DesignPackage', id: string, combinations: Array<{ __typename?: 'DesignPackageOptionCombination', id: string, name: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> }> } };

export type EditPersonalizationOptionWizard_OptionCombinationFragment = { __typename?: 'DesignPackageOptionCombination', id: string, name: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> };

export type MaterialAttributeValuesForFilterFragment = { __typename?: 'MaterialVariant', id: string, materialAttributeValues: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string, dimension: { __typename?: 'MaterialAttributeDimension', id: string, name: string } }> };

export type EditPersonalizationOptionWizard_MaterialVariantFragment = { __typename?: 'MaterialVariant', id: string, displayName: string, listing: { __typename?: 'MaterialListing', id: string, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined }, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined } | null | undefined, materialAttributeValues: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string, dimension: { __typename?: 'MaterialAttributeDimension', id: string, name: string } }> };

export type EditPersonalizationOptionWizard_Slot_TakeoffLineItemFragment = { __typename?: 'TakeoffLineItem', personalizationSlotOrder?: number | null | undefined, id: string, name: string, location: { __typename?: 'Location', id: string, displayLocationPath: string }, materialVariant?: { __typename?: 'MaterialVariant', id: string } | null | undefined, products: Array<{ __typename?: 'TakeoffLineItem', id: string, active: boolean, materialVariant?: { __typename?: 'MaterialVariant', id: string, displayName: string, listing: { __typename?: 'MaterialListing', id: string, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined }, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined } | null | undefined, materialAttributeValues: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string, dimension: { __typename?: 'MaterialAttributeDimension', id: string, name: string } }> } | null | undefined, targetCombinations: Array<{ __typename?: 'DesignPackageOptionCombination', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> }> }> };

export type EditPersonalizationOptionWizard_ProductFragment = { __typename?: 'TakeoffLineItem', id: string, active: boolean, materialVariant?: { __typename?: 'MaterialVariant', id: string, displayName: string, listing: { __typename?: 'MaterialListing', id: string, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined }, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined } | null | undefined, materialAttributeValues: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string, dimension: { __typename?: 'MaterialAttributeDimension', id: string, name: string } }> } | null | undefined, targetCombinations: Array<{ __typename?: 'DesignPackageOptionCombination', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> }> };

export type SavePersonalizationRpogWizardMutationVariables = Types.Exact<{
  input: Types.SavePersonalizationOptionGroupInput;
}>;


export type SavePersonalizationRpogWizardMutation = { __typename?: 'Mutation', savePersonalizationOptionGroup: { __typename?: 'SavePersonalizationOptionGroupResult', optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string }, version: { __typename?: 'ReadyPlanAggregateVersion', id: string } } };

export type EditPersonalizationOptionWizard_ReadyPlanOptionGroupFragment = { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, groupByFeature: boolean, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string }> };

export const EditPersonalizationOptionWizard_OptionCombinationFragmentDoc = gql`
    fragment EditPersonalizationOptionWizard_OptionCombination on DesignPackageOptionCombination {
  id
  name
  options {
    id
  }
}
    `;
export const MaterialAttributeValuesForFilterFragmentDoc = gql`
    fragment MaterialAttributeValuesForFilter on MaterialVariant {
  id
  materialAttributeValues {
    id
    textValue
    dimension {
      id
      name
    }
  }
}
    `;
export const EditPersonalizationOptionWizard_MaterialVariantFragmentDoc = gql`
    fragment EditPersonalizationOptionWizard_MaterialVariant on MaterialVariant {
  id
  displayName
  listing {
    id
    brand {
      id
      name
    }
  }
  ...MaterialAttributeValuesForFilter
  featuredImage {
    id
    asset {
      id
      previewUrl(resizing: {width: 330, region: FULL})
    }
  }
}
    ${MaterialAttributeValuesForFilterFragmentDoc}`;
export const EditPersonalizationOptionWizard_ProductFragmentDoc = gql`
    fragment EditPersonalizationOptionWizard_Product on TakeoffLineItem {
  id
  active
  materialVariant {
    ...EditPersonalizationOptionWizard_MaterialVariant
  }
  targetCombinations {
    id
    options {
      id
    }
  }
}
    ${EditPersonalizationOptionWizard_MaterialVariantFragmentDoc}`;
export const EditPersonalizationOptionWizard_Slot_TakeoffLineItemFragmentDoc = gql`
    fragment EditPersonalizationOptionWizard_Slot_TakeoffLineItem on TakeoffLineItem {
  ...Named
  personalizationSlotOrder
  location {
    id
    displayLocationPath
  }
  materialVariant {
    id
  }
  products {
    ...EditPersonalizationOptionWizard_Product
  }
}
    ${NamedFragmentDoc}
${EditPersonalizationOptionWizard_ProductFragmentDoc}`;
export const EditPersonalizationOptionWizard_ReadyPlanOptionGroupFragmentDoc = gql`
    fragment EditPersonalizationOptionWizard_ReadyPlanOptionGroup on ReadyPlanOptionGroup {
  id
  name
  options {
    id
    name
  }
  groupByFeature
}
    `;
export const EditPersonalizationOptionWizardDocument = gql`
    query EditPersonalizationOptionWizard($dpId: ID!, $rpavId: ID!, $rpogId: ID!, $isAdd: Boolean!, $forTliId: ID!, $hasTliId: Boolean!) {
  enumDetails {
    readyPlanOptionGroupPersonalizationType {
      code
      name
    }
  }
  designPackage(id: $dpId, versionId: $rpavId) {
    id
    canEdit {
      ...PotentialOperationDetails
    }
    availableTargetGroups {
      ...EditPersonalizationOptionWizard_ReadyPlanOptionGroup
    }
  }
  takeoffLineItem(id: $forTliId, versionId: $rpavId) @include(if: $hasTliId) {
    id
    ...EditPersonalizationOptionWizard_Slot_TakeoffLineItem
    targetGroups {
      id
    }
    products {
      id
      materialVariant {
        id
        ...EditPersonalizationOptionWizard_MaterialVariant
      }
    }
  }
  readyPlan(id: $dpId, versionId: $rpavId) @skip(if: $isAdd) {
    id
    optionGroups(filter: {id: [$rpogId]}) {
      id
      name
      marketingDescription
      personalizationTargetGroups {
        id
      }
      levels
      displayPackageOptionsAsSingleProduct
      groupByFeature
      personalizationPlaceholders {
        id
        personalizationRpoShadowPlaceholder {
          id
          products {
            id
            materialVariant {
              ...EditPersonalizationOptionWizard_MaterialVariant
            }
            options {
              id
            }
            placeholder {
              id
              materialVariant {
                id
              }
            }
            location {
              id
            }
          }
        }
        personalizationPlaceholderControlledSlots {
          ...EditPersonalizationOptionWizard_Slot_TakeoffLineItem
        }
      }
      personalizationType {
        code
        name
      }
      options {
        id
        name
        materialVariant {
          id
          ...EditPersonalizationOptionWizard_MaterialVariant
        }
        personalizationTargetCombinations {
          id
          options {
            id
            name
          }
        }
      }
    }
  }
}
    ${PotentialOperationDetailsFragmentDoc}
${EditPersonalizationOptionWizard_ReadyPlanOptionGroupFragmentDoc}
${EditPersonalizationOptionWizard_Slot_TakeoffLineItemFragmentDoc}
${EditPersonalizationOptionWizard_MaterialVariantFragmentDoc}`;

/**
 * __useEditPersonalizationOptionWizardQuery__
 *
 * To run a query within a React component, call `useEditPersonalizationOptionWizardQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditPersonalizationOptionWizardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditPersonalizationOptionWizardQuery({
 *   variables: {
 *      dpId: // value for 'dpId'
 *      rpavId: // value for 'rpavId'
 *      rpogId: // value for 'rpogId'
 *      isAdd: // value for 'isAdd'
 *      forTliId: // value for 'forTliId'
 *      hasTliId: // value for 'hasTliId'
 *   },
 * });
 */
export function useEditPersonalizationOptionWizardQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EditPersonalizationOptionWizardQuery, EditPersonalizationOptionWizardQueryVariables> & ({ variables: EditPersonalizationOptionWizardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EditPersonalizationOptionWizardQuery, EditPersonalizationOptionWizardQueryVariables>(EditPersonalizationOptionWizardDocument, options);
      }
export function useEditPersonalizationOptionWizardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EditPersonalizationOptionWizardQuery, EditPersonalizationOptionWizardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EditPersonalizationOptionWizardQuery, EditPersonalizationOptionWizardQueryVariables>(EditPersonalizationOptionWizardDocument, options);
        }
// @ts-ignore
export function useEditPersonalizationOptionWizardSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EditPersonalizationOptionWizardQuery, EditPersonalizationOptionWizardQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EditPersonalizationOptionWizardQuery, EditPersonalizationOptionWizardQueryVariables>;
export function useEditPersonalizationOptionWizardSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EditPersonalizationOptionWizardQuery, EditPersonalizationOptionWizardQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EditPersonalizationOptionWizardQuery | undefined, EditPersonalizationOptionWizardQueryVariables>;
export function useEditPersonalizationOptionWizardSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EditPersonalizationOptionWizardQuery, EditPersonalizationOptionWizardQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EditPersonalizationOptionWizardQuery, EditPersonalizationOptionWizardQueryVariables>(EditPersonalizationOptionWizardDocument, options);
        }
export type EditPersonalizationOptionWizardQueryHookResult = ReturnType<typeof useEditPersonalizationOptionWizardQuery>;
export type EditPersonalizationOptionWizardLazyQueryHookResult = ReturnType<typeof useEditPersonalizationOptionWizardLazyQuery>;
export type EditPersonalizationOptionWizardSuspenseQueryHookResult = ReturnType<typeof useEditPersonalizationOptionWizardSuspenseQuery>;
export type EditPersonalizationOptionWizardQueryResult = Apollo.QueryResult<EditPersonalizationOptionWizardQuery, EditPersonalizationOptionWizardQueryVariables>;
export const EditPersonalizationOptionWizard_MaterialVariantDocument = gql`
    query EditPersonalizationOptionWizard_MaterialVariant($id: ID!) {
  materialVariant(id: $id) {
    ...EditPersonalizationOptionWizard_MaterialVariant
  }
}
    ${EditPersonalizationOptionWizard_MaterialVariantFragmentDoc}`;

/**
 * __useEditPersonalizationOptionWizard_MaterialVariantQuery__
 *
 * To run a query within a React component, call `useEditPersonalizationOptionWizard_MaterialVariantQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditPersonalizationOptionWizard_MaterialVariantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditPersonalizationOptionWizard_MaterialVariantQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEditPersonalizationOptionWizard_MaterialVariantQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EditPersonalizationOptionWizard_MaterialVariantQuery, EditPersonalizationOptionWizard_MaterialVariantQueryVariables> & ({ variables: EditPersonalizationOptionWizard_MaterialVariantQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EditPersonalizationOptionWizard_MaterialVariantQuery, EditPersonalizationOptionWizard_MaterialVariantQueryVariables>(EditPersonalizationOptionWizard_MaterialVariantDocument, options);
      }
export function useEditPersonalizationOptionWizard_MaterialVariantLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EditPersonalizationOptionWizard_MaterialVariantQuery, EditPersonalizationOptionWizard_MaterialVariantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EditPersonalizationOptionWizard_MaterialVariantQuery, EditPersonalizationOptionWizard_MaterialVariantQueryVariables>(EditPersonalizationOptionWizard_MaterialVariantDocument, options);
        }
// @ts-ignore
export function useEditPersonalizationOptionWizard_MaterialVariantSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EditPersonalizationOptionWizard_MaterialVariantQuery, EditPersonalizationOptionWizard_MaterialVariantQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EditPersonalizationOptionWizard_MaterialVariantQuery, EditPersonalizationOptionWizard_MaterialVariantQueryVariables>;
export function useEditPersonalizationOptionWizard_MaterialVariantSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EditPersonalizationOptionWizard_MaterialVariantQuery, EditPersonalizationOptionWizard_MaterialVariantQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EditPersonalizationOptionWizard_MaterialVariantQuery | undefined, EditPersonalizationOptionWizard_MaterialVariantQueryVariables>;
export function useEditPersonalizationOptionWizard_MaterialVariantSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EditPersonalizationOptionWizard_MaterialVariantQuery, EditPersonalizationOptionWizard_MaterialVariantQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EditPersonalizationOptionWizard_MaterialVariantQuery, EditPersonalizationOptionWizard_MaterialVariantQueryVariables>(EditPersonalizationOptionWizard_MaterialVariantDocument, options);
        }
export type EditPersonalizationOptionWizard_MaterialVariantQueryHookResult = ReturnType<typeof useEditPersonalizationOptionWizard_MaterialVariantQuery>;
export type EditPersonalizationOptionWizard_MaterialVariantLazyQueryHookResult = ReturnType<typeof useEditPersonalizationOptionWizard_MaterialVariantLazyQuery>;
export type EditPersonalizationOptionWizard_MaterialVariantSuspenseQueryHookResult = ReturnType<typeof useEditPersonalizationOptionWizard_MaterialVariantSuspenseQuery>;
export type EditPersonalizationOptionWizard_MaterialVariantQueryResult = Apollo.QueryResult<EditPersonalizationOptionWizard_MaterialVariantQuery, EditPersonalizationOptionWizard_MaterialVariantQueryVariables>;
export const EditPersonalizationOptionWizard_CombinationsDocument = gql`
    query EditPersonalizationOptionWizard_Combinations($dpId: ID!, $rpavId: ID!, $targetGroupIds: [ID!]!) {
  designPackage(id: $dpId, versionId: $rpavId) {
    id
    combinations(optionGroupIds: $targetGroupIds) {
      ...DesignPackageProductCardPage_OptionCombination
    }
  }
}
    ${DesignPackageProductCardPage_OptionCombinationFragmentDoc}`;

/**
 * __useEditPersonalizationOptionWizard_CombinationsQuery__
 *
 * To run a query within a React component, call `useEditPersonalizationOptionWizard_CombinationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditPersonalizationOptionWizard_CombinationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditPersonalizationOptionWizard_CombinationsQuery({
 *   variables: {
 *      dpId: // value for 'dpId'
 *      rpavId: // value for 'rpavId'
 *      targetGroupIds: // value for 'targetGroupIds'
 *   },
 * });
 */
export function useEditPersonalizationOptionWizard_CombinationsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EditPersonalizationOptionWizard_CombinationsQuery, EditPersonalizationOptionWizard_CombinationsQueryVariables> & ({ variables: EditPersonalizationOptionWizard_CombinationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EditPersonalizationOptionWizard_CombinationsQuery, EditPersonalizationOptionWizard_CombinationsQueryVariables>(EditPersonalizationOptionWizard_CombinationsDocument, options);
      }
export function useEditPersonalizationOptionWizard_CombinationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EditPersonalizationOptionWizard_CombinationsQuery, EditPersonalizationOptionWizard_CombinationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EditPersonalizationOptionWizard_CombinationsQuery, EditPersonalizationOptionWizard_CombinationsQueryVariables>(EditPersonalizationOptionWizard_CombinationsDocument, options);
        }
// @ts-ignore
export function useEditPersonalizationOptionWizard_CombinationsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EditPersonalizationOptionWizard_CombinationsQuery, EditPersonalizationOptionWizard_CombinationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EditPersonalizationOptionWizard_CombinationsQuery, EditPersonalizationOptionWizard_CombinationsQueryVariables>;
export function useEditPersonalizationOptionWizard_CombinationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EditPersonalizationOptionWizard_CombinationsQuery, EditPersonalizationOptionWizard_CombinationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EditPersonalizationOptionWizard_CombinationsQuery | undefined, EditPersonalizationOptionWizard_CombinationsQueryVariables>;
export function useEditPersonalizationOptionWizard_CombinationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EditPersonalizationOptionWizard_CombinationsQuery, EditPersonalizationOptionWizard_CombinationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EditPersonalizationOptionWizard_CombinationsQuery, EditPersonalizationOptionWizard_CombinationsQueryVariables>(EditPersonalizationOptionWizard_CombinationsDocument, options);
        }
export type EditPersonalizationOptionWizard_CombinationsQueryHookResult = ReturnType<typeof useEditPersonalizationOptionWizard_CombinationsQuery>;
export type EditPersonalizationOptionWizard_CombinationsLazyQueryHookResult = ReturnType<typeof useEditPersonalizationOptionWizard_CombinationsLazyQuery>;
export type EditPersonalizationOptionWizard_CombinationsSuspenseQueryHookResult = ReturnType<typeof useEditPersonalizationOptionWizard_CombinationsSuspenseQuery>;
export type EditPersonalizationOptionWizard_CombinationsQueryResult = Apollo.QueryResult<EditPersonalizationOptionWizard_CombinationsQuery, EditPersonalizationOptionWizard_CombinationsQueryVariables>;
export const SavePersonalizationRpogWizardDocument = gql`
    mutation SavePersonalizationRpogWizard($input: SavePersonalizationOptionGroupInput!) {
  savePersonalizationOptionGroup(input: $input) {
    optionGroup {
      id
    }
    version {
      id
    }
  }
}
    `;
export type SavePersonalizationRpogWizardMutationFn = Apollo.MutationFunction<SavePersonalizationRpogWizardMutation, SavePersonalizationRpogWizardMutationVariables>;

/**
 * __useSavePersonalizationRpogWizardMutation__
 *
 * To run a mutation, you first call `useSavePersonalizationRpogWizardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePersonalizationRpogWizardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePersonalizationRpogWizardMutation, { data, loading, error }] = useSavePersonalizationRpogWizardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSavePersonalizationRpogWizardMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SavePersonalizationRpogWizardMutation, SavePersonalizationRpogWizardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SavePersonalizationRpogWizardMutation, SavePersonalizationRpogWizardMutationVariables>(SavePersonalizationRpogWizardDocument, options);
      }
export type SavePersonalizationRpogWizardMutationHookResult = ReturnType<typeof useSavePersonalizationRpogWizardMutation>;
export type SavePersonalizationRpogWizardMutationResult = Apollo.MutationResult<SavePersonalizationRpogWizardMutation>;
export type SavePersonalizationRpogWizardMutationOptions = Apollo.BaseMutationOptions<SavePersonalizationRpogWizardMutation, SavePersonalizationRpogWizardMutationVariables>;